import React, { useState, useEffect } from 'react';
import axios from 'axios';
import RoomTypeModal from './RoomTypeModal';
import RoomTypeFacilitiesTab from './RoomTypeFacilitiesTab';
import { API_BASE } from '../../config/apiBase';

const API = `${API_BASE}/manager/website`;

export default function RoomTypesTab({ token }) {
  const [roomTypes, setRoomTypes] = useState([]);
  const [modal, setModal] = useState({ open: false, editIndex: null, data: null });

  useEffect(() => {
    fetchRoomTypes();
    // eslint-disable-next-line
  }, []);

  async function fetchRoomTypes() {
    try {
      const res = await axios.get(`${API}/room-types`, { headers: { Authorization: `Bearer ${token}` } });
      setRoomTypes(res.data.data);
    } catch (err) {
      console.error(err);
    }
  }

  async function handleAddEdit(data, editIndex) {
    try {
      if (editIndex != null && roomTypes[editIndex]) {
        const id = roomTypes[editIndex].id;
        const res = await axios.put(`${API}/room-types/${id}`, data, { headers: { Authorization: `Bearer ${token}` } });
        setRoomTypes(rts => rts.map((r, i) => i === editIndex ? res.data.data : r));
      } else {
        const res = await axios.post(`${API}/room-types`, data, { headers: { Authorization: `Bearer ${token}` } });
        setRoomTypes(rts => [...rts, res.data.data]);
      }
    } catch (err) {
      alert(err.response?.data?.message || 'Failed to save room type');
    }
  }

  async function handleDelete(id) {
    if (!window.confirm('Are you sure you want to delete this room type?')) return;
    try {
      await axios.delete(`${API}/room-types/${id}`, { headers: { Authorization: `Bearer ${token}` } });
      setRoomTypes(rts => rts.filter(r => r.id !== id));
    } catch (err) {
      alert(err.response?.data?.message || 'Failed to delete room type');
    }
  }

  return (
    <div className="card">
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 18 }}>
        <button className="add-facility-btn" onClick={() => setModal({ open: true, editIndex: null, data: null })}>
          + Add Room Type
        </button>
      </div>

      <div className="facility-list">
        {roomTypes.map((rt, idx) => (
          <div key={rt.id || idx} className="facility-card">
            <div className="facility-card-header" onClick={() => setModal({ open: true, editIndex: idx, data: rt })}>
              <span className="facility-card-title">{rt.room_type}</span>
              <span style={{ color: '#888', fontSize: 13 }}>Capacity: {rt.capacity} | Price: {rt.price} PKR</span>
            </div>
            <div className="facility-card-details">
              <div><b>Description:</b> {rt.description}</div>
              <div className="facility-card-actions">
                <button onClick={() => setModal({ open: true, editIndex: idx, data: rt })}>Edit</button>
                <button onClick={() => handleDelete(rt.id)} className="delete">Delete</button>
              </div>
            </div>
          </div>
        ))}

        {roomTypes.length === 0 && <div style={{ color: '#888', textAlign: 'center', margin: '32px 0' }}>No room types added yet.</div>}
      </div>

      {modal.open && (
        <RoomTypeModal
          initial={modal.data}
          onClose={() => setModal({ open: false, editIndex: null, data: null })}
          onSave={data => handleAddEdit(data, modal.editIndex)}
        />
      )}
    </div>
  );
}
